export default "__VITE_ASSET__fsIFsFj2__"